import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import * as config from '../../shared/config/app.config';

@Injectable({
  providedIn: 'root',
})
export class CustomSearchService {
  constructor(private readonly baseService: BaseService) {}

  getSearchResults(userId) {
    return this.baseService.get(`/users/${userId}/recent-search`);
  }
  saveKeyword(params, userId) {
    this.baseService.post(`/users/${userId}/recent-search`, params).subscribe();
  }
}
